import { css } from "glamor";
import React, { useLayoutEffect, useRef, useState } from "react";
import { colors, spacing } from "../library/theme";
import Logo from "../library/images/logo-alternative.svg";

// Largura mínima da faixa para o logo/dados e o copyright caberem lado a lado.
const STACK_THRESHOLD = 960;

const container = css({
  lineHeight: 1.1,
  borderTop: "1px solid #E2E8F0",
  margin: `auto -${spacing.l} 0 -${spacing.l}`,
});
const bottomFooterBase = {
  backgroundColor: colors.greyLighter,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: spacing.m,
  padding: `${spacing.m} ${spacing.l}`,
};
const bottomFooter = css(bottomFooterBase);
// Quando não há espaço para o logo/dados e o copyright lado a lado, empilha
// tudo em coluna e centraliza, para um alinhamento central limpo.
const bottomFooterStacked = css(bottomFooterBase, {
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
});
const companyWrapperBase = {
  display: "flex",
  alignItems: "center",
  gap: spacing.m,
};
const companyWrapper = css(companyWrapperBase);
// No modo empilhado, o logo vai acima dos dados, ambos centralizados, para
// não ficarem encostados à esquerda enquanto o copyright fica no centro.
const companyWrapperStacked = css(companyWrapperBase, {
  flexDirection: "column",
});
const logoStyle = {
  height: "32px",
};
const companyInfo = css({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xs,
  fontSize: 12,
  color: colors.greyDark,
});
const copyright = css({
  fontSize: 12,
  color: colors.greyDark,
});

export default function Footer() {
  const barRef = useRef(null);
  const [stacked, setStacked] = useState(false);

  // A largura útil do footer depende da sidebar (não só do viewport). O logo +
  // dados e o copyright precisam de ~945px lado a lado; abaixo disso empilham.
  // Medimos apenas a largura da faixa (que não muda entre os dois layouts),
  // o que evita histerese e é imune ao timing de fonte/carregamento.
  useLayoutEffect(() => {
    const bar = barRef.current;
    if (!bar) return undefined;

    const measure = () => setStacked(bar.clientWidth < STACK_THRESHOLD);

    measure();

    let observer;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(measure);
      observer.observe(bar);
    }
    window.addEventListener("resize", measure);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <div className={container}>
      <div ref={barRef} className={stacked ? bottomFooterStacked : bottomFooter}>
        <div className={stacked ? companyWrapperStacked : companyWrapper}>
          <img src={Logo} style={logoStyle} />
          <div className={companyInfo}>
            <span>T2 Educação S/A - CNPJ 24.970.216/0001-48</span>
            <span>Rua Soriano de Souza, 189 - SP suporte@t2.com.br</span>
          </div>
        </div>
        <p className={copyright}>
          © {new Date().getFullYear()} T2 Educação S/A. Todos os direitos
          reservados.
        </p>
      </div>
    </div>
  );
}
